
class Validator {
	constructor (options) {
		this.$el = options.$el;

		//pass in a jquery selection of elements you want disabled if validation fails
		this.$disableElements = options.$disableElements || null;
	}

	validate () {

		this.$el.removeClass('form-control-danger').removeClass('form-control-success');
		this.$el.closest('.form-group').removeClass('has-danger').removeClass('has-success');

		var valid = this._validate(this.$el.val());

		if (valid) {
			this.success();
		} else {
			this.error();
		}

		if (this.$disableElements) {
			this.disableElements(valid);
		}

		return valid;

	}

	error () {
		this.$el.addClass('form-control-danger');
		this.$el.closest('.form-group').addClass('has-danger')

	}

	success () {
		this.$el.addClass('form-control-success');
		this.$el.closest('.form-group').addClass('has-success')

	}

	disableElements (valid) {

		if (valid) {
			this.$disableElements.attr('disabled', false);
			this.$disableElements.removeClass('disabled');
		} else {
			this.$disableElements.attr('disabled', true);
			this.$disableElements.addClass('disabled');
		}

	}

}

class EmailValidator extends Validator {
	get regex () { return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/; }

	_validate (value) {
		return this.regex.test(value)
	}

}

/**
 * For comma seperated email addresses
 * Example: "a@b.ca, a@b.com"
 */
class MultiEmailValidator extends EmailValidator {
	_validate (emails) {
		var cleanEmails = emails.replace(/ /g, '').split(",");

		var isValid = true;
		cleanEmails.forEach(email => {
			if(email) {
				if(!this.regex.test(email)) {
					isValid = false;
				}
			}
		})
		return isValid;
	}
}

module.exports = {
	EmailValidator: EmailValidator,
	MultiEmailValidator: MultiEmailValidator,
};
